import { Paper } from '@mui/material';
import { styled } from '@mui/system';
import { Container, Item } from 'Components/Grid';
import * as React from 'react';
import colors from '../../config/theme/colors';
import ToolTip from '../ToolTip';

const StyledRowContainer = styled(Container)({
  width: '100%',
});

const StyledRowItem = styled(Item)({
  width: '100%',
});

const StyledNumber = styled(StyledRowItem, {
  shouldForwardProp: prop => prop !== 'paddings' && prop !== 'disabled',
})(({ paddings, disabled }: IStyledNumberProps) => ({
  width: 'max-content',
  minWidth: '3rem',
  padding: paddings ? '0 2rem 0 2rem' : undefined,
  height: '3rem',
  backgroundColor: 'white',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  lineHeight: '2.6rem',
  border: 'solid 0.5px #cbcbcb',
  borderRadius: '5rem',
  position: 'relative',
  fontSize: '1.6rem',
  color: disabled ? colors.gray : colors.primaryText,
  fontWeight: disabled ? 'normal' : 'bold',
}));

interface IStyledNumberProps {
  disabled?: boolean;
  paddings?: boolean;
}

const StyledPaper = styled(Paper, {
  shouldForwardProp: prop =>
    !['disabled', 'selected', 'viewing', 'height'].includes(typeof prop === 'string' ? prop : ''),
})(({ disabled, selected, viewing, height }: IStyledPaperProps) => ({
  margin: '-1.5rem 0 0 0',
  padding: '3rem 1rem 1rem 1rem',
  minHeight: height ? height + 'rem' : '15rem',
  cursor: (viewing && viewing === 'true') || disabled ? undefined : 'pointer',
  fontSize: '1.6rem',
  backgroundColor:
    disabled && selected ? colors.gray : disabled ? colors.white : selected ? colors.primary : colors.white,
  color: disabled && selected ? colors.darkGray : disabled ? colors.gray : selected ? colors.white : colors.primaryText,
  '&:hover': {
    backgroundColor:
      disabled && selected
        ? colors.gray
        : disabled
          ? colors.white
          : selected
            ? colors.primary
            : viewing && viewing === 'true'
              ? colors.white
              : colors.lightestGray,
  },
}));

interface IStyledPaperProps {
  disabled?: boolean;
  selected?: boolean;
  viewing?: string;
  height?: number;
}

const QuestionItem = ({
  qNumber,
  text,
  onClick,
  selected,
  asset,
  height,
  viewing,
  disabled,
  disabledMessage,
}: IOwnProps): React.JSX.Element => {
  const Card = (
    <div>
      {/* Tooltip requires div as root element */}
      <StyledRowContainer
        style={{ visibility: `${qNumber}`.length === 0 ? 'hidden' : undefined }}
        justifyContent="center"
        alignItems="center"
      >
        <StyledNumber disabled={disabled} paddings={`${qNumber}`.length > 2}>
          {qNumber}
        </StyledNumber>
      </StyledRowContainer>
      <StyledRowContainer>
        <StyledRowItem>
          <StyledPaper
            elevation={2}
            selected={selected}
            onClick={!disabled ? onClick : undefined}
            height={height}
            viewing={viewing ? 'true' : 'false'}
            disabled={disabled}
          >
            {text}
            {asset && asset()}
          </StyledPaper>
        </StyledRowItem>
      </StyledRowContainer>
    </div>
  );

  return disabled && disabledMessage ? (
    <ToolTip title={disabledMessage} content={Card} hover={true} cursor={'Default'} />
  ) : (
    Card
  );
};

interface IOwnProps {
  qNumber: number | string;
  text: string | React.JSX.Element;
  onClick?: () => void;
  selected?: boolean;
  asset?: () => React.JSX.Element;
  height?: number;
  viewing?: boolean;
  disabled?: boolean;
  disabledMessage?: React.JSX.Element | string;
}

export default QuestionItem;
